import { useCallback, useEffect, useState } from 'react';

/**
 * Fullscreen for the whole document (wall displays). The whole page goes fullscreen, not one element, so
 * dialogs and toasts (rendered at the end of <body>) stay visible; pages hide their own chrome while `active`.
 * `supported` is false where browsers only allow it for video (iOS Safari).
 */
export function useFullscreen() {
  const supported = typeof document !== 'undefined' && !!document.fullscreenEnabled;
  const [active, setActive] = useState(() => typeof document !== 'undefined' && !!document.fullscreenElement);
  useEffect(() => {
    const onChange = () => setActive(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);
  const toggle = useCallback(() => {
    const done = document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen();
    done.catch(() => undefined); // refused (iframe, policy): the page simply stays as it is
  }, []);
  return { supported, active, toggle };
}
